import { useCallback, useRef } from 'react';
import { AttachmentCreate } from 'src/models/attachments/attachment-create.model';

export const useAttachmentControl = () => {
    const filesRef = useRef<AttachmentCreate[]>([]);
    const setNewAttachments = useCallback(
        (attachments: AttachmentCreate[]) => {
            filesRef.current = [...attachments];
        },
        [filesRef]
    );

    return { filesRef, setNewAttachments };
};
